require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-what-did-a-review-of-the-banks-climate-finance-por.json") })
        }
      }, "path---en-us-update-what-did-a-review-of-the-banks-climate-finance-por");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-what-did-a-review-of-the-banks-climate-finance-por!./.cache/json/en-us-update-what-did-a-review-of-the-banks-climate-finance-por.json
// module id = 832
// module chunks = 231608221292675